module.exports = __webpack_public_path__ + "img/credential.ee305670.svg";